export var isDev = false;